// AUTO-GENERATED by scripts/gen-version.js — do not edit or commit.
export const BUILD_ID = "7ec56eeb";
